exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntr td.half-padding[data-v-19a164cc] {\n  padding: 4px;\n}\ntr[data-v-19a164cc]:not(.selected):hover {\n  background-color: #1890ff0a;\n}\ntr.selected[data-v-19a164cc] {\n  background-color: #1890ff1c;\n}\ntable th.compact[data-v-19a164cc],\ntable td.compact[data-v-19a164cc] {\n  white-space: nowrap;\n  width: 1px !important;\n}\ntr .pencil-icon.edit-name[data-v-19a164cc] {\n  display: none;\n}\ntr:hover .pencil-icon.edit-name[data-v-19a164cc] {\n  display: initial;\n}\n", ""]);

// exports
